import React, { useState, useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import POFooterStyle from './css/POFooterStyle'
import { ContentFooter } from '../../../layout/Content'
import POListController from '../polist/POListController'
import POItemController from '../poitem/POItemController'
import { poControllerContext } from './POController'
import { appContext } from '../../../../App'

function POFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const poController = useContext(poControllerContext)
  const po = poController.po[0]
  const savePO = poController.po[2]
  const [newRecordCount, setNewRecordCount] = useState(0)
  const [successMessage, setSuccessMessage] = useState(false)
  const [postOK, setPostOK] = useState(null)

  const onClickPost = (e) => {
    po.status = 'Posted'
    //if action is present delete if first to avoid double (edit) save
    delete po.action
    savePO(app, po)
    .then(saved_po => {
      if (saved_po) {
        setSuccessMessage('Posted successfully! Loading PO Item, Please wait...')
        setNewRecordCount(newRecordCount + 1)
        setTimeout(() => {
          setSuccessMessage('')
          setContent(<POItemController poItem={saved_po}/>)
        }, 1000)
      }
    })
  }

  useEffect(() => {
    setPostOK(
      po.date_prepared &&
      po.prepared_by &&
      (po.item_details.length > 0)
    )
  }, [po])

  return (
    <ContentFooter>
        <div id="messagebox-container"></div>
        <div id="po-footer-container">
          <span id='new-record-count-container'>
            <span style={{visibility: newRecordCount ? 'visible' : 'hidden'}} id='new-record-count'>
              { newRecordCount ?
                  `${newRecordCount} new record(s) added`
                : null
              }
            </span>
            <span style={{visibility: successMessage ? 'visible' : 'hidden'}} className='notification'>{successMessage}</span>
          </span>
          <div className='translist-button-container'>
            <button className="pospro-action-btn"
              id="trans-list-btn"
              type="button"
              onClick={() => setContent(<POListController />)}>
              <FontAwesomeIcon icon='list-alt'/>&nbsp;Transactions List
            </button>
            <button className={ !postOK ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }
              id="post-item-btn"
              type="button"
              disabled={!postOK}
              onClick={onClickPost}>
              <FontAwesomeIcon icon='save'/>&nbsp;Post
            </button>
          </div>
        </div>
        <POFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(POFooter)
